import React, { useState } from 'react'

// icons
import { AiOutlineClose } from "react-icons/ai";

// bootstrap
import { Spinner } from "react-bootstrap";

// components
import StepLogin from './includes/StepLogin'
import StepRegister from './includes/StepRegister';
import StepGuest from './includes/StepGuest';

export default function RightCheckoutBar(props) {

    // props
    const {
        isActive,
        setRightMenuVisibility,

        isGuestUser,
        setIsGuestUser,

        existingEmail,
        setExistingEmail,
    } = props

    const [sectionLoading, setSectionLoading] = useState(false)

    return (
        <div className={`right-checkbout-bar-overlay ${isActive ? "active" : ""}`} onClick={() => setRightMenuVisibility(false)}>
            <div className="right-checkbout-bar" onClick={ev => ev.stopPropagation()}>
                <div className="inner">
                    <div className="close-icon">
                        <a href="/" onClick={ev => {
                            ev.preventDefault()
                            setRightMenuVisibility(false)
                        }}>
                            <AiOutlineClose />
                        </a>
                    </div>
                    {/* frac */}
                    <StepGuest
                        setSectionLoading={setSectionLoading}
                        setRightMenuVisibility={setRightMenuVisibility}

                        isGuestUser={isGuestUser}
                        setIsGuestUser={setIsGuestUser}

                        setExistingEmail={setExistingEmail}
                    />


                    {/* frac */}
                    <StepLogin
                        setSectionLoading={setSectionLoading}
                        setRightMenuVisibility={setRightMenuVisibility}

                        existingEmail={existingEmail}
                    />

                    {/* frac */}
                    <StepRegister
                        setSectionLoading={setSectionLoading}
                        setRightMenuVisibility={setRightMenuVisibility}
                    />
                </div>

                {
                    /* LOADING */
                    sectionLoading ? (
                        <div className="section-loading position-absolute align-items-center d-flex h-100 justify-content-center section-loading w-100" style={{ top: 0, left: 0, background: "rgba(255,255,255,0.5)" }}>
                            <Spinner animation="border" />
                        </div>
                    ) : null
                }
            </div>
        </div>
    )
}
